import { CommonModule } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { FormsModule } from '@angular/forms';

import {
  Room,
  RoomEvent,
  RemoteTrack,
  Track,
  LocalAudioTrack,
  createLocalAudioTrack
} from 'livekit-client';

import { catchError, firstValueFrom, Observable, throwError, timeout } from 'rxjs';
import { AgentServiceService } from './agent-service.service';
import { ToastModule } from 'primeng/toast';

export interface Transcript {

  id: string;

  text: string;

  isAgent: boolean;

  final?: boolean;

}

interface TranscriptSegment {

  id: string;

  text: string;

  final: boolean;

}

export const CONFIG = {
  agentUrl: 'https://agentic.canstringai.com',

  agentId: 'f3841d32-8577-49a1-965a-744708f70edc',

  agent_secret_key: 'kJ8mP2nQ_xZv4tY9bN3rL5wF7sH-aE6cR1uW0iO_dGq',

  variables: {
    customer_name: 'Visitor'
  },

  auto_connect: false,

};


export interface TokenResponse {

  room_name: string;

  token: string;

  url: string;

}

export interface Agent {
  id: number;
  agent_name: string;
  agent_id: string;
}

export const agentList: Agent[] = [

  {
    id: 1,
    agent_name: 'AI Agent',
    agent_id: 'fabea43b-a970-4dae-a051-4522f0955087'
  },

  {
    id: 2,
    agent_name: 'Absence Assistance',
    agent_id: 'f3841d32-8577-49a1-965a-744708f70edc'
  }

];

@Component({
  selector: 'app-talk-ai-agent',

  standalone: true,

  imports: [

    CommonModule,

    FormsModule,

    ToastModule

  ],

  templateUrl: './talk-ai-agent.component.html',

  styleUrl: './talk-ai-agent.component.scss'

})


export class TalkAiAgentComponent

  implements OnInit, OnDestroy {

  @HostBinding('class.flex-grid')
  leftBarClass = true;

  @HostBinding('style.width')
  flexWidth = '100%';

  @HostBinding('style.flex-direction')
  direction: 'column' | 'row' = 'column';

  @ViewChild('transcriptContainer', { static: false })
  transcriptContainer?: ElementRef<HTMLDivElement>;

  /* LiveKit */
  room: Room | null = null;

  /* Connection */
  connected = false;
  connecting = false;
  connectLabel = 'Connect';
  muted = false;

  /* UI */
  panelOpen = false;
  fullscreen = false;
  statusText = 'Ready';
  statusState: 'default' | 'connecting' | 'connected' = 'default';
  toastMessage = '';

  /* Transcript */
  readonly transcriptMap = new Map<string, Transcript>();
  transcripts: Transcript[] = [];

  /* Timer */
  seconds = 0;
  timer = '0:00';
  timerInterval?: ReturnType<typeof setInterval>;

  /* Audio */
  isSpeaking = false;
  remoteAudioElements: HTMLAudioElement[] = [];

  /* Agent Data */
  agents: Agent[] = agentList;
  voices: any[] = [];

  selectedAgent: Agent | null = null;
  selectedVoice: any | null = null;

  provider: any[] = [
    {
      id: 1,
      name: 'Canstring Voice',
      provider: 'omnivoice'
    },
    {
      id: 2,
      name: 'ElevenLabs',
      provider: 'elevenlabs'
    }
  ];

  elevenVoice: any[] = [
    { id: "EXAVITQu4vr4xnSDxMaL", name: "Sarah", gender: 'female' },
    { id: "cgSgspJ2msm6clMCkdW9", name: "Jessica", gender: 'female' },
    { id: "JBFqnCBsd6RMkjVDRZzb", name: "George", gender: 'male' },
    { id: "Xb7hH8MSUJpSbSDYk0k2", name: "Alice", gender: 'female' },
    { id: "hpp4J3VqNfWAUOO0d1Us", name: "Bella", gender: 'female' },
    { id: "CwhRBWXzGAHq8TQ4Fs17", name: "Roger", gender: 'male' },
    { id: "FGY2WhTYpPnrIDTdsKH5", name: "Laura", gender: 'male' },
    { id: "IKne3meq5aSn9XLyUdCD", name: "Charlie", gender: 'male' },
    { id: "N2lVS1w4EtoT3dr4eOWO", name: "Callum", gender: 'male' },
    { id: "SAz9YHcvj6GT2YYXdXww", name: "River", gender: 'male' },
    { id: "yK2Ny0mq8WplixhD1td3", name: "Caroline Braden", gender: 'female' }
  ];

  canstringVoice: any[] = [
    { id: "viraj", name: "viraj-us-m", gender: 'male' },
    { id: "anna", name: "anna-us-f", gender: 'female' },
    { id: "lexi", name: "lexi-us-f", gender: 'female' },
    { id: "max", name: "max-us-m", gender: 'male' },
    { id: "ram_ka", name: "ram_ka", gender: 'male' },
    { id: "ram_ml", name: "ram_ml", gender: 'male' }
  ];

  // Selected values
  selectedProvider: any = null;

  voiceList: any[] = [];


  maleAvatar = 'assets/images/ai_avatar/ai_male_avatar_img.png';
  maleSpeakingAvatar = 'assets/images/ai_avatar/ai_male_avatar.gif';

  femaleAvatar = 'assets/images/ai_avatar/ai_female_avatar_img.png';
  femaleSpeakingAvatar = 'assets/images/ai_avatar/ai_female_avatar.gif';

  agentIsSpeaking = false;

  /* Chat */
  typedMessage = '';

  /* Voice Animation */
  readonly bars = [
    { delay: '0s' },
    { delay: '.1s' },
    { delay: '.2s' },
    { delay: '.05s' },
    { delay: '.15s' },
    { delay: '.25s' },
    { delay: '.08s' },
    { delay: '.18s' },
    { delay: '.12s' }
  ] as const;

  constructor(

    private readonly http: HttpClient,

    private readonly zone: NgZone,

    private readonly agentService: AgentServiceService,

    private readonly cdr: ChangeDetectorRef

  ) { }

  // ngOnInit(): void {
  //   if (CONFIG.auto_connect) {
  //     void this.handleConnect();
  //   }
  // }

  // get tokenEndpoint(): string {
  //   return `${CONFIG.agentUrl}/api/agent/${this.selectedAgent?.agent_id ?? ''}`;
  // }

  // get agentGender(): 'male' | 'female' {
  //   return this.selectedVoice?.gender === 'female'
  //     ? 'female'
  //     : 'male';
  // }

  // get agentAvatar(): string {

  //   if (this.agentGender === 'female') {
  //     return this.agentIsSpeaking
  //       ? 'assets/images/avatar/female-speaking.gif'
  //       : 'assets/images/avatar/female.png';
  //   }

  //   return this.agentIsSpeaking
  //     ? 'assets/images/avatar/male-speaking.gif'
  //     : 'assets/images/avatar/male.png';
  // }
  // async handleConnect(): Promise<void> {

  //   if (!this.selectedAgent) {
  //     this.showToast('Please select an agent');
  //     return;
  //   }

  //   if (!this.selectedVoice) {
  //     this.showToast('Please select a voice');
  //     return;
  //   }

  //   if (this.connecting || this.connected) {
  //     return;
  //   }

  //   this.connecting = true;
  //   this.connectLabel = 'Connecting...';
  //   this.statusText = 'Connecting...';
  //   this.statusState = 'connecting';

  //   try {

  //     const { token, url } = await this.fetchToken();

  //     if (!token || !url) {
  //       throw new Error('Invalid token response.');
  //     }

  //     this.room = new Room({
  //       adaptiveStream: true,
  //       dynacast: true,
  //       audioCaptureDefaults: {
  //         echoCancellation: true,
  //         noiseSuppression: true,
  //         autoGainControl: true
  //       }
  //     });

  //     this.registerRoomEvents();

  //     await this.room.connect(url, token);

  //     const audioTrack: LocalAudioTrack =
  //       await createLocalAudioTrack({
  //         echoCancellation: true,
  //         noiseSuppression: true,
  //         autoGainControl: true
  //       });

  //     // await this.room.localParticipant.setMicrophoneEnabled(true);

  //     await this.room.localParticipant.publishTrack(audioTrack);

  //     // Let RoomEvent.Connected update the UI state
  //     this.showToast('Connected successfully');

  //   } catch (error) {

  //     console.error('Connection Error:', error);

  //     const message =
  //       error instanceof Error
  //         ? error.message
  //         : 'Failed to connect';

  //     this.showToast(message);

  //     await this.cleanupRoom();

  //   } finally {

  //     this.connecting = false;

  //   }
  // }


  // async handleMute(): Promise<void> {

  //   if (!this.room || !this.connected) {
  //     return;
  //   }

  //   const previousState = this.muted;

  //   try {

  //     this.muted = !this.muted;

  //     await this.room.localParticipant.setMicrophoneEnabled(!this.muted);

  //     this.showToast(
  //       this.muted
  //         ? 'Microphone muted'
  //         : 'Microphone unmuted'
  //     );

  //   } catch (error) {

  //     this.muted = previousState;

  //     console.error('Mute Error:', error);

  //     this.showToast(
  //       error instanceof Error
  //         ? error.message
  //         : 'Unable to change microphone state'
  //     );

  //   }

  // }

  // private toastTimer?: ReturnType<typeof setTimeout>;

  // private showToast(message: string, duration = 2000): void {

  //   this.toastMessage = message;

  //   if (this.toastTimer) {
  //     clearTimeout(this.toastTimer);
  //   }

  //   this.toastTimer = setTimeout(() => {
  //     this.toastMessage = '';
  //     this.toastTimer = undefined;
  //   }, duration);

  // }

  // async sendTypedMessage(): Promise<void> {

  //   const text = this.typedMessage.trim();

  //   if (!text || !this.connected || !this.room) {
  //     return;
  //   }

  //   const userMessageId = crypto.randomUUID();

  //   this.updateTranscript(
  //     userMessageId,
  //     text,
  //     false,
  //     true
  //   );

  //   this.typedMessage = '';

  //   try {

  //     await this.room.localParticipant.sendText(text, {
  //       topic: 'lk.chat'
  //     });

  //     this.scrollToBottom();

  //   } catch (error) {

  //     console.error('LiveKit send error:', error);

  //     this.typedMessage = text;

  //     this.removeTranscript(userMessageId);

  //     this.showToast(
  //       error instanceof Error
  //         ? error.message
  //         : 'Failed to send message'
  //     );

  //   }

  // }

  // private removeTranscript(id: string): void {

  //   const index = this.transcripts.findIndex(t => t.id === id);

  //   if (index === -1) {
  //     return;
  //   }

  //   this.transcripts.splice(index, 1);

  //   // Remove from lookup map
  //   this.transcriptMap.delete(id);

  //   // Trigger Angular change detection
  //   this.transcripts = [...this.transcripts];

  //   this.scrollToBottom();

  // }

  // askAgent(question: string): Observable<any> {

  //   if (!this.selectedAgent) {
  //     return throwError(() => new Error('Please select an agent.'));
  //   }

  //   if (!this.selectedVoice) {
  //     return throwError(() => new Error('Please select a voice.'));
  //   }

  //   const payload = {
  //     agent_id: this.selectedAgent.agent_id,
  //     question: question.trim(),
  //     tts_provider: 'omnivoice',
  //     tts_speaker: this.selectedVoice.voice,
  //     tts_model: ''
  //   };

  //   return this.http.post<any>(
  //     `${CONFIG.agentUrl}/api/chat`,
  //     payload
  //   ).pipe(
  //     timeout(30000),
  //     catchError((error: HttpErrorResponse) => {
  //       console.error('Chat API Error:', error);

  //       return throwError(() =>
  //         new Error(
  //           error.error?.message ||
  //           error.message ||
  //           'Unable to contact the AI agent.'
  //         )
  //       );
  //     })
  //   );

  // }

  // async handleEnd(): Promise<void> {

  //   if (!this.connected || !this.room) {
  //     return;
  //   }

  //   this.connecting = true;

  //   try {

  //     await this.cleanupRoom();

  //     this.showToast('Call ended');

  //   } catch (error) {

  //     console.error('Disconnect Error:', error);

  //     this.showToast(
  //       error instanceof Error
  //         ? error.message
  //         : 'Failed to disconnect'
  //     );

  //   } finally {

  //     this.connecting = false;

  //   }

  // }

  // async fetchToken(): Promise<TokenResponse> {

  //   if (!this.selectedAgent) {
  //     throw new Error('Please select an agent.');
  //   }

  //   if (!this.selectedVoice) {
  //     throw new Error('Please select a voice.');
  //   }

  //   const body = {
  //     agentId: this.selectedAgent.agent_id,
  //     tts_provider: this.selectedProvider.provider,
  //     tts_speaker: this.selectedVoice.voice, // or this.selectedVoice.voice_id
  //     tts_model: this.selectedProvider.provider === 'elevenlabs' ? 'eleven_turbo_v2_5' : 'omnivoice',
  //     customer_name: 'Visitor'
  //   };

  //   try {

  //     const response: any = await firstValueFrom(
  //       this.agentService.selectAIAgent(body)
  //     );

  //     if (!response?.token || !response?.url) {
  //       throw new Error('Invalid token response.');
  //     }

  //     return response as TokenResponse;

  //   } catch (error) {

  //     console.error('Fetch Token Error:', error);

  //     throw error instanceof Error
  //       ? error
  //       : new Error('Unable to fetch connection token.');

  //   }

  // }

  // onAgentChange(): void {

  //   if (!this.selectedAgent) {
  //     return;
  //   }

  //   // Prevent changing agent during an active session
  //   if (this.connected) {
  //     this.showToast('Please disconnect before changing the agent.');
  //     return;
  //   }

  //   // Reset provider and voice selections
  //   this.selectedProvider = null;
  //   this.selectedVoice = null;

  //   // Reset voice list
  //   this.voiceList = [];
  //   this.voices = [];

  //   // Load custom voices for selected agent
  //   // this.getCustomVoice();

  //   this.showToast(
  //     `${this.selectedAgent.agent_name} selected`
  //   );
  // }


  // onProviderChange(provider: any): void {

  //   this.selectedProvider = provider;

  //   // Reset voice whenever provider changes
  //   this.selectedVoice = null;

  //   if (!provider) {
  //     this.voiceList = [];
  //     return;
  //   }

  //   if (provider.provider === 'omnivoice') {
  //     this.voiceList = [...this.canstringVoice];
  //   }

  //   else if (provider.provider === 'elevenlabs') {
  //     this.voiceList = [...this.elevenVoice];
  //   }

  //   else {
  //     this.voiceList = [];
  //   }
  // }

  // getCustomVoice(): void {

  //   if (!this.selectedAgent) {
  //     return;
  //   }

  //   this.voices = [];
  //   this.selectedVoice = null;

  //   this.agentService
  //     .getCustomVoice() // or getCustomVoice(this.selectedAgent.agent_id)
  //     .subscribe({
  //       next: (response: any) => {

  //         this.voices = response?.voices ?? [];

  //         if (!this.voices.length) {
  //           this.showToast('No voices available.');
  //         }

  //       },
  //       error: (error) => {

  //         console.error('Error loading voices:', error);

  //         this.voices = [];
  //         this.selectedVoice = null;

  //         this.showToast(
  //           error instanceof Error
  //             ? error.message
  //             : 'Unable to load voices'
  //         );

  //       }
  //     });

  // }

  // onChangeVoice(): void {

  //   if (!this.selectedVoice) {
  //     return;
  //   }

  //   this.showToast(`${this.selectedVoice.voice} selected`);

  // }


  // private readonly textDecoder = new TextDecoder();

  // private registerRoomEvents(): void {

  //   if (!this.room) {
  //     return;
  //   }

  //   // Remove old listeners
  //   this.room.removeAllListeners();

  //   // Connected
  //   this.room.on(RoomEvent.Connected, () => {
  //     this.zone.run(() => {

  //       this.connected = true;
  //       this.connecting = false;

  //       this.connectLabel = 'Connected';
  //       this.statusText = `Connected · ${this.selectedAgent?.agent_name ?? ''}`;
  //       this.statusState = 'connected';

  //       this.startTimer();

  //       console.log('Room Connected');
  //     });
  //   });

  //   // Disconnected
  //   this.room.on(RoomEvent.Disconnected, () => {
  //     this.zone.run(() => {

  //       this.connected = false;
  //       this.connecting = false;
  //       this.muted = false;
  //       this.isSpeaking = false;

  //       this.connectLabel = 'Connect';
  //       this.statusText = 'Disconnected';
  //       this.statusState = 'default';

  //       this.stopTimer();

  //       this.remoteAudioElements.forEach(audio => {
  //         audio.pause();
  //         audio.srcObject = null;
  //         audio.remove();
  //       });

  //       this.remoteAudioElements = [];

  //       console.log('Room Disconnected');
  //     });
  //   });

  //   // Remote Audio Track
  //   this.room.on(RoomEvent.TrackSubscribed, (track: RemoteTrack) => {

  //     if (track.kind !== Track.Kind.Audio) {
  //       return;
  //     }

  //     const audio = track.attach() as HTMLAudioElement;

  //     audio.autoplay = true;
  //     audio.controls = false;
  //     audio.style.display = 'none';

  //     audio.play().catch(err => {
  //       console.error('Audio playback failed:', err);
  //     });

  //     this.remoteAudioElements.push(audio);
  //     document.body.appendChild(audio);

  //     console.log('Audio Track Subscribed');
  //   });

  //   // Remote Audio Removed
  //   this.room.on(RoomEvent.TrackUnsubscribed, (track: RemoteTrack) => {

  //     if (track.kind !== Track.Kind.Audio) {
  //       return;
  //     }

  //     track.detach().forEach(element => {
  //       if (element instanceof HTMLAudioElement) {
  //         element.pause();
  //         element.srcObject = null;
  //       }
  //       element.remove();
  //     });

  //     this.remoteAudioElements = this.remoteAudioElements.filter(audio =>
  //       document.body.contains(audio)
  //     );

  //     console.log('Audio Track Unsubscribed');
  //   });

  //   // Active Speaker
  //   // this.room.on(RoomEvent.ActiveSpeakersChanged, speakers => {
  //   //   this.zone.run(() => {
  //   //     this.isSpeaking = speakers.some(speaker => !speaker.isLocal);
  //   //   });
  //   // });

  //   this.room.on(RoomEvent.ActiveSpeakersChanged, speakers => {

  //     this.zone.run(() => {

  //       this.agentIsSpeaking = speakers.some(
  //         speaker => !speaker.isLocal
  //       );

  //       this.isSpeaking = speakers.some(
  //         speaker => speaker.isLocal
  //       );

  //       this.isSpeaking = this.agentIsSpeaking;

  //       this.cdr.markForCheck();
  //     });

  //   });

  //   // Speech-to-Text
  //   this.room.on(
  //     RoomEvent.TranscriptionReceived,
  //     (segments: TranscriptSegment[], participant) => {

  //       this.zone.run(() => {

  //         const isAgent = participant ? !participant.isLocal : false;

  //         segments.forEach(segment => {
  //           this.updateTranscript(
  //             segment.id,
  //             segment.text,
  //             isAgent,
  //             segment.final
  //           );
  //         });

  //         this.scrollToBottom();
  //       });
  //     }
  //   );

  //   // Chat Messages
  //   this.room.on(
  //     RoomEvent.DataReceived,
  //     (payload, participant, _kind, topic) => {

  //       if (topic !== 'lk.chat') {
  //         return;
  //       }

  //       const text = this.textDecoder.decode(payload).trim();

  //       if (!text) {
  //         return;
  //       }

  //       this.zone.run(() => {

  //         this.updateTranscript(
  //           crypto.randomUUID(),
  //           text,
  //           participant ? !participant.isLocal : true,
  //           true
  //         );

  //         this.scrollToBottom();

  //       });
  //     }
  //   );

  //   // Connection Quality
  //   this.room.on(RoomEvent.ConnectionQualityChanged, quality => {
  //     console.log('Connection Quality:', quality);
  //   });

  //   // Media Device Error
  //   this.room.on(RoomEvent.MediaDevicesError, error => {

  //     console.error('Media Device Error:', error);

  //     this.zone.run(() => {
  //       this.showToast(
  //         error instanceof Error
  //           ? error.message
  //           : 'Microphone access failed',
  //         3000
  //       );
  //     });

  //   });

  // }

  // updateTranscript(
  //   id: string,
  //   text: string,
  //   isAgent: boolean,
  //   final: boolean
  // ): void {

  //   const message = text.trim();

  //   if (!message) {
  //     return;
  //   }

  //   const existing = this.transcriptMap.get(id);

  //   if (existing) {

  //     // Update partial transcript
  //     existing.text = message;
  //     existing.final = final;

  //   } else {

  //     const transcript: Transcript = {
  //       id,
  //       text: message,
  //       isAgent,
  //       final
  //     };

  //     this.transcriptMap.set(id, transcript);
  //     this.transcripts.push(transcript);
  //   }

  //   // Refresh UI
  //   this.transcripts = [...this.transcripts];

  //   // Scroll after DOM update
  //   queueMicrotask(() => this.scrollToBottom());

  //   // If using OnPush change detection
  //   // this.cdr.markForCheck();
  // }

  // clearTranscripts(): void {

  //   if (!this.transcripts.length) {
  //     return;
  //   }

  //   this.transcriptMap.clear();
  //   this.transcripts = [];

  //   queueMicrotask(() => this.scrollToBottom());

  //   // If using OnPush change detection
  //   // this.cdr.markForCheck();
  // }

  // startTimer(): void {

  //   this.stopTimer();

  //   this.seconds = 0;
  //   this.timer = '0:00';

  //   this.timerInterval = setInterval(() => {

  //     this.seconds++;

  //     const minutes = Math.floor(this.seconds / 60);
  //     const seconds = this.seconds % 60;

  //     this.timer = `${minutes}:${seconds.toString().padStart(2, '0')}`;

  //   }, 1000);

  // }

  // private stopTimer(): void {

  //   if (this.timerInterval) {
  //     clearInterval(this.timerInterval);
  //     this.timerInterval = undefined;
  //   }

  //   this.seconds = 0;
  //   this.timer = '0:00';

  // }

  // private scrollToBottom(): void {

  //   const element = this.transcriptContainer?.nativeElement;

  //   if (!element) {
  //     return;
  //   }

  //   requestAnimationFrame(() => {
  //     element.scrollTo({
  //       top: element.scrollHeight,
  //       behavior: 'smooth'
  //     });
  //   });

  // }

  // private async cleanupRoom(): Promise<void> {

  //   this.stopTimer();

  //   if (this.room) {

  //     try {

  //       // Disable microphone before disconnecting
  //       await this.room.localParticipant.setMicrophoneEnabled(false);

  //       await this.room.disconnect();

  //     } catch (error) {

  //       console.error('Room disconnect error:', error);

  //     } finally {

  //       this.room.removeAllListeners();
  //       this.room = null;

  //     }

  //   }

  //   this.remoteAudioElements.forEach(audio => {
  //     audio.pause();
  //     audio.srcObject = null;
  //     audio.remove();
  //   });

  //   this.remoteAudioElements = [];

  //   this.connected = false;
  //   this.connecting = false;
  //   this.muted = false;
  //   this.isSpeaking = false;

  //   this.connectLabel = 'Connect';
  //   this.statusText = 'Ready';
  //   this.statusState = 'default';

  //   // Optional
  //   // this.clearTranscripts();

  // }

  // async ngOnDestroy(): Promise<void> {

  //   await this.cleanupRoom();

  // }


  // ============================================================
  // INITIALIZATION
  // ============================================================

  ngOnInit(): void {
    if (CONFIG.auto_connect) {
      void this.handleConnect();
    }
  }


  // ============================================================
  // AGENT / AVATAR
  // ============================================================

  get tokenEndpoint(): string {
    return `${CONFIG.agentUrl}/api/agent/${this.selectedAgent?.agent_id ?? ''}`;
  }

  get agentGender(): 'male' | 'female' {
    return this.selectedVoice?.gender === 'female'
      ? 'female'
      : 'male';
  }

  get agentAvatar(): string {
    if (this.agentGender === 'female') {
      return this.agentIsSpeaking
        ? this.femaleSpeakingAvatar
        : this.femaleAvatar;
    }

    return this.agentIsSpeaking
      ? this.maleSpeakingAvatar
      : this.maleAvatar;
  }


  // ============================================================
  // CONNECT
  // ============================================================

  async handleConnect(): Promise<void> {

    if (!this.selectedAgent) {
      this.showToast('Please select an agent');
      return;
    }

    if (!this.selectedProvider) {
      this.showToast('Please select a voice provider');
      return;
    }

    if (!this.selectedVoice) {
      this.showToast('Please select a voice');
      return;
    }

    if (this.connecting || this.connected) {
      return;
    }

    this.connecting = true;
    this.connectLabel = 'Connecting...';
    this.statusText = 'Connecting...';
    this.statusState = 'connecting';

    try {

      const { token, url } = await this.fetchToken();

      if (!token || !url) {
        throw new Error('Invalid token response.');
      }

      // --------------------------------------------------------
      // Create LiveKit Room
      // --------------------------------------------------------

      this.room = new Room({
        adaptiveStream: true,
        dynacast: true,

        audioCaptureDefaults: {
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true
        }
      });

      // --------------------------------------------------------
      // Register events BEFORE connect
      // --------------------------------------------------------

      this.registerRoomEvents();

      // --------------------------------------------------------
      // Connect
      // --------------------------------------------------------

      await this.room.connect(url, token);

      // --------------------------------------------------------
      // Enable microphone
      // LiveKit creates/publishes the microphone track
      // --------------------------------------------------------

      await this.room.localParticipant.setMicrophoneEnabled(true);

      this.muted = false;

      this.showToast('Connected successfully');

    } catch (error) {

      console.error('Connection Error:', error);

      const message =
        error instanceof Error
          ? error.message
          : 'Failed to connect';

      this.showToast(message);

      await this.cleanupRoom();

    } finally {

      this.connecting = false;
    }
  }


  // ============================================================
  // MUTE / UNMUTE
  // ============================================================

  async handleMute(): Promise<void> {

    if (!this.room || !this.connected) {
      return;
    }

    const previousState = this.muted;

    try {

      const newMutedState = !this.muted;

      this.muted = newMutedState;

      await this.room.localParticipant.setMicrophoneEnabled(
        !newMutedState
      );

      this.showToast(
        newMutedState
          ? 'Microphone muted'
          : 'Microphone unmuted'
      );

    } catch (error) {

      this.muted = previousState;

      console.error('Mute Error:', error);

      this.showToast(
        error instanceof Error
          ? error.message
          : 'Unable to change microphone state'
      );
    }
  }


  // ============================================================
  // TOAST
  // ============================================================

  private toastTimer?: ReturnType<typeof setTimeout>;

  private showToast(
    message: string,
    duration = 2000
  ): void {

    this.toastMessage = message;

    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }

    this.toastTimer = setTimeout(() => {

      this.toastMessage = '';
      this.toastTimer = undefined;

    }, duration);
  }


  // ============================================================
  // SEND TYPED MESSAGE
  // ============================================================

  async sendTypedMessage(): Promise<void> {

    const text = this.typedMessage.trim();

    if (!text || !this.connected || !this.room) {
      return;
    }

    const userMessageId = crypto.randomUUID();

    this.updateTranscript(
      userMessageId,
      text,
      false,
      true
    );

    this.typedMessage = '';

    try {

      await this.room.localParticipant.sendText(
        text,
        {
          topic: 'lk.chat'
        }
      );

      this.scrollToBottom();

    } catch (error) {

      console.error('LiveKit send error:', error);

      this.typedMessage = text;

      this.removeTranscript(userMessageId);

      this.showToast(
        error instanceof Error
          ? error.message
          : 'Failed to send message'
      );
    }
  }


  // ============================================================
  // REMOVE TRANSCRIPT
  // ============================================================

  private removeTranscript(id: string): void {

    const index = this.transcripts.findIndex(
      transcript => transcript.id === id
    );

    if (index === -1) {
      return;
    }

    this.transcripts.splice(index, 1);

    this.transcriptMap.delete(id);

    this.transcripts = [...this.transcripts];

    this.scrollToBottom();
  }


  // ============================================================
  // ASK AGENT API
  // ============================================================

  askAgent(question: string): Observable<any> {

    if (!this.selectedAgent) {
      return throwError(
        () => new Error('Please select an agent.')
      );
    }

    if (!this.selectedProvider) {
      return throwError(
        () => new Error('Please select a voice provider.')
      );
    }

    if (!this.selectedVoice) {
      return throwError(
        () => new Error('Please select a voice.')
      );
    }

    const payload = {

      agent_id: this.selectedAgent.agent_id,

      question: question.trim(),

      tts_provider: this.selectedProvider.provider,

      tts_speaker: this.selectedVoice.id,

      tts_model:
        this.selectedProvider.provider === 'elevenlabs'
          ? 'eleven_turbo_v2_5'
          : 'omnivoice'
    };

    return this.http.post<any>(
      `${CONFIG.agentUrl}/api/chat`,
      payload
    ).pipe(

      timeout(30000),

      catchError((error: HttpErrorResponse) => {

        console.error(
          'Chat API Error:',
          error
        );

        return throwError(
          () =>
            new Error(
              error.error?.message ||
              error.message ||
              'Unable to contact the AI agent.'
            )
        );
      })
    );
  }


  // ============================================================
  // END CALL
  // ============================================================

  async handleEnd(): Promise<void> {

    if (!this.connected && !this.room) {
      return;
    }

    this.connecting = true;

    try {

      await this.cleanupRoom();

      this.showToast('Call ended');

    } catch (error) {

      console.error(
        'Disconnect Error:',
        error
      );

      this.showToast(
        error instanceof Error
          ? error.message
          : 'Failed to disconnect'
      );

    } finally {

      this.connecting = false;
    }
  }


  // ============================================================
  // FETCH TOKEN
  // ============================================================

  async fetchToken(): Promise<TokenResponse> {

    if (!this.selectedAgent) {
      throw new Error('Please select an agent.');
    }

    if (!this.selectedProvider) {
      throw new Error('Please select a voice provider.');
    }

    if (!this.selectedVoice) {
      throw new Error('Please select a voice.');
    }

    const body = {

      agentId: this.selectedAgent.agent_id,

      tts_provider:
        this.selectedProvider.provider,

      tts_speaker:
        this.selectedVoice.id,

      tts_model:
        this.selectedProvider.provider === 'elevenlabs'
          ? 'eleven_turbo_v2_5'
          : 'omnivoice',

      customer_name: 'Visitor'
    };

    try {

      const response: any =
        await firstValueFrom(
          this.agentService.selectAIAgent(body)
        );

      if (
        !response?.token ||
        !response?.url
      ) {
        throw new Error(
          'Invalid token response.'
        );
      }

      return response as TokenResponse;

    } catch (error) {

      console.error(
        'Fetch Token Error:',
        error
      );

      throw error instanceof Error
        ? error
        : new Error(
          'Unable to fetch connection token.'
        );
    }
  }


  // ============================================================
  // AGENT CHANGE
  // ============================================================

  onAgentChange(): void {

    if (!this.selectedAgent) {
      return;
    }

    if (this.connected || this.connecting) {

      this.showToast(
        'Please disconnect before changing the agent.'
      );

      return;
    }

    this.selectedProvider = null;
    this.selectedVoice = null;

    this.voiceList = [];
    this.voices = [];

    this.agentIsSpeaking = false;
    this.isSpeaking = false;

    this.showToast(
      `${this.selectedAgent.agent_name} selected`
    );

    this.cdr.markForCheck();
  }


  // ============================================================
  // PROVIDER CHANGE
  // ============================================================

  onProviderChange(provider: any): void {

    if (this.connected || this.connecting) {

      this.showToast(
        'Please disconnect before changing the provider.'
      );

      return;
    }

    this.selectedProvider = provider;

    this.selectedVoice = null;

    this.voiceList = [];
    this.voices = [];

    this.agentIsSpeaking = false;

    if (!provider) {
      return;
    }

    if (provider.provider === 'omnivoice') {

      this.voiceList = [
        ...this.canstringVoice
      ];

    } else if (
      provider.provider === 'elevenlabs'
    ) {

      this.voiceList = [
        ...this.elevenVoice
      ];

    } else {

      this.voiceList = [];
    }

    this.cdr.markForCheck();
  }


  // ============================================================
  // CUSTOM VOICES
  // ============================================================

  getCustomVoice(): void {

    if (!this.selectedAgent) {
      return;
    }

    this.voices = [];
    this.selectedVoice = null;

    this.agentService
      .getCustomVoice()
      .subscribe({

        next: (response: any) => {

          this.voices =
            response?.voices ?? [];

          if (!this.voices.length) {

            this.showToast(
              'No voices available.'
            );
          }

          this.cdr.markForCheck();
        },

        error: (error) => {

          console.error(
            'Error loading voices:',
            error
          );

          this.voices = [];
          this.selectedVoice = null;

          this.showToast(
            error instanceof Error
              ? error.message
              : 'Unable to load voices'
          );

          this.cdr.markForCheck();
        }
      });
  }


  // ============================================================
  // VOICE CHANGE
  // ============================================================

  onChangeVoice(): void {

    if (!this.selectedVoice) {
      return;
    }

    this.agentIsSpeaking = false;

    console.log(
      'Selected Voice:',
      this.selectedVoice
    );

    console.log(
      'Voice Gender:',
      this.selectedVoice.gender
    );

    console.log(
      'Agent Gender:',
      this.agentGender
    );

    console.log(
      'Agent Avatar:',
      this.agentAvatar
    );

    this.showToast(
      `${this.selectedVoice.voice} selected`
    );

    this.cdr.markForCheck();
  }


  // ============================================================
  // TEXT DECODER
  // ============================================================

  private readonly textDecoder =
    new TextDecoder();


  // ============================================================
  // LIVEKIT ROOM EVENTS
  // ============================================================

  private registerRoomEvents(): void {

    if (!this.room) {
      return;
    }

    this.room.removeAllListeners();


    // ==========================================================
    // CONNECTED
    // ==========================================================

    this.room.on(
      RoomEvent.Connected,
      () => {

        this.zone.run(() => {

          this.connected = true;
          this.connecting = false;

          this.connectLabel = 'Connected';

          this.statusText =
            `Connected · ${this.selectedAgent?.agent_name ?? ''
            }`;

          this.statusState = 'connected';

          this.startTimer();

          this.agentIsSpeaking = false;
          this.isSpeaking = false;

          this.cdr.markForCheck();

          console.log(
            'LiveKit Room Connected'
          );
        });
      }
    );


    // ==========================================================
    // DISCONNECTED
    // ==========================================================

    this.room.on(
      RoomEvent.Disconnected,
      () => {

        this.zone.run(() => {

          this.connected = false;
          this.connecting = false;

          this.muted = false;

          this.agentIsSpeaking = false;
          this.isSpeaking = false;

          this.connectLabel = 'Connect';

          this.statusText =
            'Disconnected';

          this.statusState = 'default';

          this.stopTimer();

          this.removeRemoteAudioElements();

          this.cdr.markForCheck();

          console.log(
            'LiveKit Room Disconnected'
          );
        });
      }
    );


    // ==========================================================
    // REMOTE AUDIO TRACK
    // ==========================================================

    this.room.on(
      RoomEvent.TrackSubscribed,
      (
        track: RemoteTrack
      ) => {

        if (
          track.kind !== Track.Kind.Audio
        ) {
          return;
        }

        const audio =
          track.attach() as HTMLAudioElement;

        audio.autoplay = true;
        audio.controls = false;
        // audio.playsInline = true;

        audio.style.display = 'none';

        document.body.appendChild(audio);

        this.remoteAudioElements.push(
          audio
        );

        audio.play().catch(error => {

          console.error(
            'Audio playback failed:',
            error
          );
        });

        console.log(
          'Audio Track Subscribed'
        );
      }
    );


    // ==========================================================
    // REMOTE AUDIO REMOVED
    // ==========================================================

    this.room.on(
      RoomEvent.TrackUnsubscribed,
      (
        track: RemoteTrack
      ) => {

        if (
          track.kind !== Track.Kind.Audio
        ) {
          return;
        }

        track.detach().forEach(
          element => {

            if (
              element instanceof
              HTMLAudioElement
            ) {

              element.pause();
              element.srcObject = null;
            }

            element.remove();
          }
        );

        this.remoteAudioElements =
          this.remoteAudioElements.filter(
            audio =>
              document.body.contains(audio)
          );

        console.log(
          'Audio Track Unsubscribed'
        );
      }
    );


    // ==========================================================
    // ACTIVE SPEAKERS
    // ==========================================================

    this.room.on(
      RoomEvent.ActiveSpeakersChanged,
      speakers => {
        this.zone.run(() => {

          this.isSpeaking = speakers.some(
            speaker => speaker.isLocal
          );

          this.agentIsSpeaking = speakers.some(
            speaker => !speaker.isLocal
          );

          this.cdr.markForCheck();
        });
      }
    );


    // ==========================================================
    // SPEECH TO TEXT
    // ==========================================================

    this.room.on(
      RoomEvent.TranscriptionReceived,
      (
        segments: TranscriptSegment[],
        participant
      ) => {

        this.zone.run(() => {

          const isAgent =
            participant
              ? !participant.isLocal
              : false;

          segments.forEach(
            segment => {

              this.updateTranscript(
                segment.id,
                segment.text,
                isAgent,
                segment.final
              );
            }
          );

          this.scrollToBottom();

          this.cdr.markForCheck();
        });
      }
    );


    // ==========================================================
    // CHAT DATA
    // ==========================================================

    this.room.on(
      RoomEvent.DataReceived,
      (
        payload,
        participant,
        _kind,
        topic
      ) => {

        if (topic !== 'lk.chat') {
          return;
        }

        const text =
          this.textDecoder
            .decode(payload)
            .trim();

        if (!text) {
          return;
        }

        this.zone.run(() => {

          this.updateTranscript(
            crypto.randomUUID(),
            text,
            participant
              ? !participant.isLocal
              : true,
            true
          );

          this.scrollToBottom();

          this.cdr.markForCheck();
        });
      }
    );


    // ==========================================================
    // CONNECTION QUALITY
    // ==========================================================

    this.room.on(
      RoomEvent.ConnectionQualityChanged,
      (
        quality
      ) => {

        console.log(
          'Connection Quality:',
          quality
        );
      }
    );


    // ==========================================================
    // MEDIA DEVICE ERROR
    // ==========================================================

    this.room.on(
      RoomEvent.MediaDevicesError,
      error => {

        console.error(
          'Media Device Error:',
          error
        );

        this.zone.run(() => {

          this.showToast(
            error instanceof Error
              ? error.message
              : 'Microphone access failed',
            3000
          );

          this.cdr.markForCheck();
        });
      }
    );
  }


  // ============================================================
  // TRANSCRIPT UPDATE
  // ============================================================

  updateTranscript(
    id: string,
    text: string,
    isAgent: boolean,
    final: boolean
  ): void {

    const message =
      text.trim();

    if (!message) {
      return;
    }

    const existing =
      this.transcriptMap.get(id);

    if (existing) {

      existing.text = message;
      existing.final = final;
      existing.isAgent = isAgent;

    } else {

      const transcript: Transcript = {

        id,

        text: message,

        isAgent,

        final
      };

      this.transcriptMap.set(
        id,
        transcript
      );

      this.transcripts.push(
        transcript
      );
    }

    this.transcripts = [
      ...this.transcripts
    ];

    queueMicrotask(
      () => this.scrollToBottom()
    );
  }


  // ============================================================
  // CLEAR TRANSCRIPTS
  // ============================================================

  clearTranscripts(): void {

    if (!this.transcripts.length) {
      return;
    }

    this.transcriptMap.clear();

    this.transcripts = [];

    queueMicrotask(
      () => this.scrollToBottom()
    );

    this.cdr.markForCheck();
  }


  // ============================================================
  // TIMER
  // ============================================================

  startTimer(): void {

    this.stopTimer();

    this.seconds = 0;

    this.timer = '0:00';

    this.timerInterval =
      setInterval(() => {

        this.seconds++;

        const minutes =
          Math.floor(
            this.seconds / 60
          );

        const seconds =
          this.seconds % 60;

        this.timer =
          `${minutes}:${seconds
            .toString()
            .padStart(2, '0')}`;

        this.cdr.markForCheck();

      }, 1000);
  }


  private stopTimer(): void {

    if (this.timerInterval) {

      clearInterval(
        this.timerInterval
      );

      this.timerInterval =
        undefined;
    }

    this.seconds = 0;

    this.timer = '0:00';
  }


  // ============================================================
  // SCROLL TRANSCRIPT
  // ============================================================

  private scrollToBottom(): void {

    const element =
      this.transcriptContainer
        ?.nativeElement;

    if (!element) {
      return;
    }

    requestAnimationFrame(() => {

      element.scrollTo({
        top: element.scrollHeight,
        behavior: 'smooth'
      });

    });
  }


  // ============================================================
  // REMOVE REMOTE AUDIO
  // ============================================================

  private removeRemoteAudioElements(): void {

    this.remoteAudioElements
      .forEach(audio => {

        try {
          audio.pause();
        } catch {
          // Ignore
        }

        audio.srcObject = null;
        audio.remove();
      });

    this.remoteAudioElements = [];
  }


  // ============================================================
  // CLEANUP LIVEKIT ROOM
  // ============================================================

  private async cleanupRoom(): Promise<void> {

    this.stopTimer();

    this.agentIsSpeaking = false;
    this.isSpeaking = false;

    if (this.room) {

      const room =
        this.room;

      try {

        // Disable microphone
        if (room.localParticipant) {

          await room.localParticipant
            .setMicrophoneEnabled(false);
        }

        // Disconnect
        await room.disconnect();

      } catch (error) {

        console.error(
          'Room disconnect error:',
          error
        );

      } finally {

        room.removeAllListeners();

        this.room = null;
      }
    }

    this.removeRemoteAudioElements();

    this.connected = false;
    this.connecting = false;
    this.muted = false;

    this.agentIsSpeaking = false;
    this.isSpeaking = false;

    this.connectLabel = 'Connect';
    this.statusText = 'Ready';
    this.statusState = 'default';

    this.cdr.markForCheck();
  }


  // ============================================================
  // DESTROY
  // ============================================================

  async ngOnDestroy(): Promise<void> {

    if (this.toastTimer) {

      clearTimeout(
        this.toastTimer
      );

      this.toastTimer =
        undefined;
    }

    await this.cleanupRoom();
  }

}
